import * as api from '../api';

// Action Types
export const GET_CHAT_DATA_REQUEST = 'GET_CHAT_DATA_REQUEST';
export const GET_CHAT_DATA_SUCCESS = 'GET_CHAT_DATA_SUCCESS';
export const GET_CHAT_DATA_FAILURE = 'GET_CHAT_DATA_FAILURE';

export const SAVE_CHAT_REQUEST = 'SAVE_CHAT_REQUEST';
export const SAVE_CHAT_SUCCESS = 'SAVE_CHAT_SUCCESS';
export const SAVE_CHAT_FAILURE = 'SAVE_CHAT_FAILURE';

export const GET_USER_CHATS_REQUEST = 'GET_USER_CHATS_REQUEST';
export const GET_USER_CHATS_SUCCESS = 'GET_USER_CHATS_SUCCESS';
export const GET_USER_CHATS_FAILURE = 'GET_USER_CHATS_FAILURE';

export const DELETE_CHAT_REQUEST = 'DELETE_CHAT_REQUEST';
export const DELETE_CHAT_SUCCESS = 'DELETE_CHAT_SUCCESS';
export const DELETE_CHAT_FAILURE = 'DELETE_CHAT_FAILURE';

// Action Creators
export const getChatData = (message) => async (dispatch) => {
    try {
        dispatch({ type: GET_CHAT_DATA_REQUEST });
        const response = await api.fetchChatData(message);
        dispatch({ type: GET_CHAT_DATA_SUCCESS, payload: response.data });
        return response.data;
    } catch (error) {
        dispatch({ type: GET_CHAT_DATA_FAILURE, payload: error.message });
        throw error;
    }
};

export const saveChat = (messages, chatId) => async (dispatch) => {
    try {
        dispatch({ type: SAVE_CHAT_REQUEST });
        const response = await api.saveChat(messages, chatId);
        dispatch({ type: SAVE_CHAT_SUCCESS, payload: response.data });
        return response.data;
    } catch (error) {
        dispatch({ type: SAVE_CHAT_FAILURE, payload: error.message });
        throw error;
    }
};

export const getUserChats = () => async (dispatch) => {
    try {
        dispatch({ type: GET_USER_CHATS_REQUEST });
        const response = await api.fetchUserChats();
        dispatch({ type: GET_USER_CHATS_SUCCESS, payload: response.data });
        return response.data;
    } catch (error) {
        dispatch({ type: GET_USER_CHATS_FAILURE, payload: error.message });
        throw error;
    }
};

// Add this with your other action creators
export const deleteChat = (chatId) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_CHAT_REQUEST });
        
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        await api.deleteChat(chatId, token);
        
        dispatch({ 
            type: DELETE_CHAT_SUCCESS, 
            payload: chatId 
        });
        
        return { success: true };
    } catch (error) {
        dispatch({ 
            type: DELETE_CHAT_FAILURE, 
            payload: error.message 
        });
        throw error;
    }
};